import Plugin from 'src/plugin-system/plugin.class';

export default class FooterPlugin extends Plugin {

    init() {

        return;

        if ($('.elementor-editor-active').length) {
            return;
        }

        this._resizeFooter();
        this._registerEvents();
    }

    _resizeFooter() {
        var footerHeight = $(this.el).outerHeight();
        $('body').css('padding-bottom', footerHeight + 'px');
    }

    _registerEvents() {
        $(window).on('resize', () => {
            this._resizeFooter();
        });
    }
}